// Utilitários de cor pra decidir contraste de texto sobre fundos dinâmicos (ex: badges de status).

/**
 * Decide se o texto sobre uma cor de fundo deve ser claro ou escuro,
 * usando a fórmula de luminância perceptual (YIQ).
 * @param {string} bgColor - Cor de fundo em hexadecimal (ex: "#2e7d32")
 * @returns {string} "#333" ou "#fff"
 */
export const getContrastTextColor = (bgColor) => {
  const hex = bgColor.replace('#', '');
  const r = parseInt(hex.substr(0, 2), 16);
  const g = parseInt(hex.substr(2, 2), 16);
  const b = parseInt(hex.substr(4, 2), 16);
  const brightness = (r * 299 + g * 587 + b * 114) / 1000;
  return brightness > 128 ? '#333' : '#fff';
};
